'use client';

const CombinationsListSkeleton = () => {
  return <div className='flex flex-col gap-2' data-sentry-component="CombinationsListSkeleton" data-sentry-source-file="combinations-list-skeleton.tsx">
            <div className='h-4 w-full animate-pulse rounded bg-gray-100' />
            <div className='h-4 w-full animate-pulse rounded bg-gray-100' />
        </div>;
};
export default CombinationsListSkeleton;